app.controller(
    'PreviewController', ['$scope', '$rootScope', '$stateParams', '$translate', '$sce', 'GroupService', 'SideBarService', 'BioService', 'PlaceService', 'DistrictService', 'FlaneriesService', 'HelperService', PreviewController]
);

function PreviewController($scope, $rootScope, $stateParams, $translate, $sce, GroupService, SideBarService, BioService, PlaceService, DistrictService, FlaneriesService, HelperService) {
    var vm = this;

    vm.BioVm = {};
    vm.GroupVm = {};
    vm.ItineraryVm = {};
    vm.DistrictVm = {};
    vm.PlaceVm = {};

    vm.PreviewType = $stateParams.type;
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($scope.CurrentLang);

    initController();

    function initController() {
        if (vm.PreviewType == 'group') {
            loadGroup($stateParams.id, $stateParams.lang);
        }
        if (vm.PreviewType == 'bio') {
            loadBio($stateParams.id, $stateParams.lang);
        }
        if (vm.PreviewType == 'district') {
            loadDistrict($stateParams.id, $stateParams.lang);
        }
        if (vm.PreviewType == 'place') {
            loadPlace($stateParams.id, $stateParams.lang);
        }
        if (vm.PreviewType == 'itinerary') {
            loadItinerary($stateParams.id, $stateParams.lang);
        }       
    }

    function loadGroup(groupId, lang) {
        GroupService.GetGroupPreview(groupId, lang)
            .then(function (group) {
                vm.GroupVm = group;                
                if (vm.GroupVm.DescriptionList.length > 0) {
                    vm.ActiveDescriptionId = 0;
                    vm.ActiveDescription = vm.GroupVm.DescriptionList[vm.ActiveDescriptionId];
                }
                
            });
        HelperService.GetAssociatedPlacesOnSideBar(groupId, 17, lang, false)
                .then(function (data) {
                    vm.AssociatedPlaces = data;
                });
    }

    function loadBio(bioId, lang) {
        BioService.GetBioPreview(bioId, lang)
            .then(function (bio) {
                vm.BioVm = bio.data;

                if (vm.BioVm.DescriptionList.length > 0) {
                    vm.ActiveDescriptionId = 0;
                    vm.ActiveDescription = vm.BioVm.DescriptionList[vm.ActiveDescriptionId];
                }                                
            });

        HelperService.GetAssociatedPlacesOnSideBar(bioId, 59, lang, false)
                .then(function (data) {                    
                    vm.AssociatedPlaces = data;
                });
    }

    function loadDistrict(id, lang) {
        DistrictService.GetDistrictPreview(id, lang)
        .then(function (t) {
            var res = t.data;
            vm.DistrictVm = res;            
        });
        HelperService.GetAssociatedPlacesOnSideBar(id, 16, lang, false)
                .then(function (data) {
                    vm.AssociatedPlaces = data;
                });
    }

    function loadPlace(id, lang) {
        PlaceService.GetPlacePreview(id, lang)
        .then(function (t) {
            var res = t.data;
            vm.PlaceVm = res;            
        });
        HelperService.GetAssociatedPlacesOnSideBar(id, 12, lang, false)
                .then(function (data) {
                    vm.AssociatedPlaces = data;
                });
    }

    function loadItinerary(id, lang) {
        FlaneriesService.GetItineraryPreview(id, lang)
        .then(function (t) {
            var res = t.data;
            vm.ItineraryVm = res;
            $rootScope.SideBar = res.SideBar;
                        
        });
        HelperService.GetAssociatedPlacesOnSideBar(id, 15, lang, false)
                .then(function (data) {
                    vm.AssociatedPlaces = data;
                });
    }

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };
}

